import React, { useEffect } from "react";
import { NavLink } from "react-router-dom";

import { Header } from "../../components/header";
import { Icon } from "../../components/icon";

export const Apps = [
  {
    name: "Quản lí tài liệu",
    icon: <Icon.Compose />,
    path: "/document",
    image: "/assets/images/app-document-management.png",
  },
  {
    name: "Xử lý văn bản",
    icon: <Icon.Compose />,
    path: "/image2text",
    image: "/assets/images/app-document-management.png",
  },
  {
    name: "Cấu hình",
    icon: <Icon.Setting />,
    path: "/setting",
    image: "/assets/images/app-settings.png",
  },
  {
    name: "QUY TRÌNH VĂN PHÒNG ĐIỆN TỬ",
    icon: <Icon.Procedure />,
    path: "/procedure/",
    image: "/assets/images/app-procedure.png",
  },
  {
    name: "Quản lí công việc",
    icon: <Icon.TaskManagement />,
    path: "/task",
    image: "/assets/images/app-task-management.png",
  },
  {
    name: "Công việc của tôi",
    icon: <Icon.Tasks />,
    path: "/my-task",
    image: "/assets/images/app-my-tasks.png",
  },
  {
    name: "Hỗ trợ 24/7",
    icon: <Icon.Support />,
    path: "/support",
    image: "/assets/images/app-support.png",
    url: "https://teams.microsoft.com/l/chat/0/0?users=28:5a8989bc-7a93-4e89-8cd2-9083e385b477",
  },
  {
    name: "Hướng dẫn",
    icon: <Icon.Info />,
    path: "/intro",
    image: "/assets/images/app-introduce.png",
  },
];

export const HomePage = () => {
  useEffect(() => {
    // EventsService.getEventById("AAMkAGUxNGU2NzFjLTA1NjgtNGI5Yi1hZDkyLTBjYWJiZTBlYjA3OQBGAAAAAABy49ZIg8bdTLXtaUf6rwofBwCdX6rVBlJcRaZrq4GktWw3AAAAAAENAACdX6rVBlJcRaZrq4GktWw3AAAmHODXAAA").then(res => {
    //   console.log(res);
    // }, error => {
    //   console.log(error);
    // });
    // UserService.getUsers().then(res => {
    //   console.log(res);
    // }, error => {
    //   console.log(error);
    // });
    // EmployeeService.getEmployees().then(res => {
    //   dispatch(setEmployeesAct(res));
    // }, error => {
    //   console.log(error);
    // });
    // MailService.sendMail({
    //   "message": {
    //     "subject": "Meet for lunch 1?",
    //     "body": {
    //       "contentType": "Text",
    //       "content": "The new cafeteria is open."
    //     },
    //     "toRecipients": [
    //       {
    //         "emailAddress": {
    //           "address": "canbo1@viags.vn"
    //         }
    //       }
    //     ]
    //   }
    // }).then(res => {
    //   console.log(res);
    // }, error => {
    //   console.log(error);
    // });
    // EventsService.addEvent().then(res => {
    //   console.log(res);
    // }, error => {
    //   console.log(error);
    // });
    // EventsService.updateEvent({}).then(res => {
    //   console.log(res);
    // }, error => {
    //   console.log(error);
    // });
  }, []);
  return (
    <>
      <Header />
      <div className="HomePage">
        <div className="container">
          <div className="sectionTitle">Danh sách chức năng</div>
          <div className="NavigateList">
            <div className="row">
              {Apps.map((item, key) => (
                <div className="col-sm-3" key={key}>
                  {item.url ? (
                    // eslint-disable-next-line react/jsx-no-target-blank
                    <a className="item" href={item.url} target={"_blank"}>
                      <img src={item.image} alt={item.name} />
                      <div className="information">
                        <div className="name">
                          {item.icon}
                          {item.name}
                        </div>
                      </div>
                    </a>
                  ) : (
                    <NavLink className="item" to={item.path}>
                      <img src={item.image} alt={item.name} />
                      <div className="information">
                        <div className="name">
                          {item.icon}
                          {item.name}
                        </div>
                      </div>
                    </NavLink>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
